export const UNFREEZE_APPLY_LIST_ROUTE_PAGE_PATH = '/unfreezeApply/list'
